import React, { useState, useRef, useEffect } from "react"; // <--- Add useRef
import Styles from "./CreateTender.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import Fileupload from "../../../../commons/Inputs/FileUpload/Fileupload";
import { saveAs } from "file-saver";
import FileDownloadIcon from "../../../../assets/images/Download_brand.svg";
import DateInput from "../../../../commons/Inputs/DateInputBailateral/DateInput";
import TimeInput from "../../../../commons/Inputs/TimeInputBailateral/TimeInput";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

import {
  createListing,
  editListing,
} from "../../../../Services/BuySell/Creation";
import { useDispatch, useSelector } from "react-redux";
import {
  createAuctionTender,
  terminateTender,
  updateAuctionTender,
} from "../../../../Services/ReverseAuction/AlterApi";
import { formatDateElement } from "../../../../commons/FormatDate";
import {
  getAllGenerators,
  getSelfGenerators,
} from "../../../../Services/ReverseAuction/GetApi";
import { handleInviteParticipants } from "../../../../Services/ReverseAuction/AlterApi";
import SelectParticipant from "../SelectParticipants/SelectParticipant";
import TenderTemplate from "../../../../assets/docs/Listing_Reverse_Auction.xlsx";
import RfqTemplate from "../../../../assets/docs/RFP_RFQ_for_Custom.xlsx";
import { toast } from "react-toastify";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";
import { toastProperties } from "../../../../commons/Toast/Toaster";
import AuctionDateInput from "../../../../commons/Inputs/Auction/AuctionDateInput/AuctionDateInput";
import AuctionTimeInput from "../../../../commons/Inputs/Auction/AuctionTimeInput/AuctionTimeInput";
import CircularProgress from "@mui/material/CircularProgress";
import { auctionGet } from "../../../../Redux/Slices/auctionSlice";
import { activeType2Loading } from "../../../../Redux/Slices/notificationSlice";
import { usePdfPreview } from "../../../../hooks/usePdfPreview";

const checkAreSame = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // This works because both will produce "Thu Nov 06 2025"
  return d1.toDateString() === d2.toDateString();
};

const CreateTender = ({
  open,
  handleClose,
  listingMode,
  type,
  editData,
  duplicate,
  rfq,
}) => {
  const companyId = useSelector(
    (state) => state?.persistedReducer?.user?.company?.companyId,
  );
  const isTrader = useSelector((state) => state?.persistedReducer);
  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();
  const uploadLock = useRef(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state?.persistedReducer?.userType);
  const [excelUpload, setExcelUpload] = useState({});
  const [error, setError] = useState({});
  const stateListMain = useSelector((state) => state?.persistedReducer?.user);
  const stateId = stateListMain?.consumers?.filter(
    (ele) => ele?.consumerId === stateListMain?.activeConsumerId,
  )[0]?.stateUtId;

  const mapingData = useSelector((s) => s?.platformSlice?.userPaymentConfigs);
  const paymentConfigurationId = mapingData?.filter(
    (ele) => ele?.productName === "RFP_RFQ",
  )?.[0]?.configurations?.[0]?.configurationId;
  const paymentConfigurationIdBil = mapingData?.filter(
    (ele) => ele?.productName === "BILATERAL",
  )?.[0]?.configurations?.[0]?.configurationId;

  const reqList = editData?.requisitions || [
    {
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      quantity: "",
      minQty: "",
    },
  ];
  const tenderData = editData || {};

  const [requisitions, setRequisitions] = useState(
    type === "edit"
      ? reqList.map((item) => ({
          startDate: item.dateStartAt || "",
          endDate: item.dateEndAt || "",
          startTime: item.slotStartAt || "",
          endTime: item.slotEndAt || "",
          quantity: item.requiredQty || "",
          price: item.landingCost || "",
          minQty: item.minimumQty || "",
        }))
      : [
          {
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
            quantity: "",
            price: "",
            minQty: "",
          },
        ],
  );
  const [tenderStartDate, setTenderStartDate] = useState(
    type === "edit" ? new Date(tenderData?.tenderStartDate) : "",
  );
  const [tenderEndDate, setTenderEndDate] = useState(
    type === "edit" ? new Date(tenderData?.tenderEndDate) : "",
  );
  const [tenderStartTime, setTenderStartTime] = useState(
    type === "edit" ? tenderData?.tenderStartTime : "",
  );
  const [tenderEndTime, setTenderEndTime] = useState(
    type === "edit" ? tenderData?.tenderEndTime : "",
  );
  const [biddingStartDate, setBiddingStartDate] = useState(
    type === "edit" ? new Date(tenderData?.biddingStartDate) : "",
  );
  const [biddingEndDate, setBiddingEndDate] = useState(
    type === "edit" ? new Date(tenderData?.biddingEndDate) : "",
  );
  const [biddingStartTime, setBiddingStartTime] = useState(
    type === "edit" ? tenderData?.biddingStartTime : "",
  );
  const [biddingEndTime, setBiddingEndTime] = useState(
    type === "edit" ? tenderData?.biddingEndTime : "",
  );
  const [reverseAuctionStartDate, setReverseAuctionStartDate] = useState(
    type === "edit" && !rfq
      ? new Date(tenderData?.reverseAuctionStartDate)
      : "",
  );
  const [reverseAuctionEndDate, setReverseAuctionEndDate] = useState(
    type === "edit" && !rfq ? new Date(tenderData?.reverseAuctionEndDate) : "",
  );
  const [reverseAuctionStartTime, setReverseAuctionStartTime] = useState(
    type === "edit" && !rfq ? tenderData?.reverseAuctionStartTime : "",
  );
  const [reverseAuctionEndTime, setReverseAuctionEndTime] = useState(
    type === "edit" && !rfq ? tenderData?.reverseAuctionEndTime : "",
  );
  const [initialMargin, setInitialMargin] = useState(
    type === "edit" ? tenderData?.initialMargin : 100,
  );
  const [Emd, setEmd] = useState(
    type === "edit" ? tenderData?.Emd : rfq ? 0 : 0,
  );

  const [paymentSecurity, setPaymentSecurity] = useState(
    type === "edit" ? tenderData?.paymentSecurity : 1,
  );
  const [comment, setComment] = useState(
    type === "edit" ? tenderData?.comments : "",
  );
  const [generalTC, setGeneralTC] = useState(
    type === "edit" ? tenderData?.generalTC : null,
  );

  const [tenderType, setTenderType] = useState(
    duplicate && rfq
      ? "CLOSED"
      : type === "edit"
        ? tenderData?.auctionType
        : rfq
          ? "CLOSED"
          : "OPEN",
  );

  const [tcm, setTcm] = useState("no");

  const [selectModal, setSelectModal] = useState(false);
  const [selcHeader, setSelcHeader] = useState("Select Participants");

  const [selModalData, setSelModalData] = useState([]);
  const [defData, setDefData] = useState(
    type === "edit"
      ? tenderData?.auctionParticipants
      : rfq
        ? [10, 11, 12, 14, 15]
        : [],
  );
  const [participants, setParticipants] = useState(
    duplicate ? [] : tenderData?.auctionParticipants || [],
  );

  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [confirmHeader, setConfirmHeader] = useState("");
  const [switchTypeModal, setSwitchTypeModal] = useState(false);
  const [pendingType, setPendingType] = useState(null);
  const [editClosed, setEditClosed] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [acceptSystemTerms, setAcceptSystemTerms] = useState(false);

  const trader = useSelector((state) => state?.persistedReducer);

  useEffect(() => {
    if (rfq && type !== "edit") {
      handleTenderType("CLOSED");
    }
  }, [rfq]);

  const handleTenderStartDate = (value) => setTenderStartDate(value);
  const handleTenderEndDate = (value) => setTenderEndDate(value);
  const handleTenderStartTime = (value) => setTenderStartTime(value);
  const handleTenderEndTime = (value) =>
    setTenderEndTime(value === "24:00" ? "23:59" : value);
  const handleBiddingStartDate = (value) => setBiddingStartDate(value);
  const handleBiddingEndDate = (value) => setBiddingEndDate(value);
  const handleBiddingStartTime = (value) => setBiddingStartTime(value);
  const handleBiddingEndTime = (value) =>
    setBiddingEndTime(value === "24:00" ? "23:59" : value);
  const handleReverseAuctionStartDate = (value) =>
    setReverseAuctionStartDate(value);
  const handleReverseAuctionEndDate = (value) =>
    setReverseAuctionEndDate(value);
  const handleReverseAuctionStartTime = (value) =>
    setReverseAuctionStartTime(value);
  const handleReverseAuctionEndTime = (value) =>
    setReverseAuctionEndTime(value === "24:00" ? "23:59" : value);
  //   setPaymentSecurity(value);
  // };
  const handleComment = (value) => setComment(value);
  const handleGeneralTC = (value) => setGeneralTC(value?.id);

  async function handleDownloadExcel() {
    try {
      const date = new Date();

      // Format date
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      const dateString = `${day}-${month}-${year}`;

      let fileUrl = "";
      let fileName = "";

      // Select file + dynamic filename
      if (rfq) {
        fileUrl = RfqTemplate;
        fileName = `Rfq_${dateString}.xlsx`;
      } else {
        fileUrl = TenderTemplate;
        fileName = `Tender_${dateString}.xlsx`;
      }

      const response = await fetch(fileUrl);
      const blob = await response.blob();

      saveAs(
        new Blob([blob], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        fileName,
      );
    } catch (error) {}
  }

  const handleExcelUploadRA = (sheetData, fileName) => {
    if (uploadLock.current || !sheetData || sheetData.length === 0) return;

    uploadLock.current = true;
    setTimeout(() => {
      uploadLock.current = false;
    }, 1000);

    // Debug: log what XLSX actually returned so we can trace format issues

    // Month name → 0-based index map for "DD-Mon-YY(YY)" format (e.g. "10-Jun-26")
    const MONTH_MAP = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11,
    };

    const excelSerialDateToJSDate = (serial) => {
      if (serial == null || serial === "" || isNaN(serial)) return null;
      const n = Number(serial);
      if (n <= 0) return null;
      const msPerDay = 24 * 60 * 60 * 1000;
      const date = new Date(Math.round((n - 25569) * msPerDay));
      return isNaN(date.getTime()) ? null : date;
    };

    const parseExcelDate = (val) => {
      if (val == null || val === "") return null;
      let finalDate = null;

      if (val instanceof Date) {
        finalDate = val;
      } else if (typeof val === "number") {
        // Excel serial number (dates are > 25569 which is 1970-01-01)
        finalDate = excelSerialDateToJSDate(val);
      } else {
        const s = String(val).trim();

        // 5-digit (or 6-digit) pure integer → likely an Excel serial date
        // (e.g. "45813" when cell has no date format applied)
        if (/^\d{5,6}$/.test(s)) {
          finalDate = excelSerialDateToJSDate(Number(s));
        }
        // "YYYY-MM-DD"
        else if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
          const [y, m, d] = s.split("-");
          finalDate = new Date(+y, +m - 1, +d);
        }
        // "DD-MM-YYYY" or "DD/MM/YYYY"
        else if (/^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/.test(s)) {
          const [d, m, y] = s.split(/[-/]/);
          finalDate = new Date(+y, +m - 1, +d);
        }
        // "DD-Mon-YY" or "DD-Mon-YYYY" e.g. "10-Jun-26", "01-Jul-2026"
        else if (/^\d{1,2}[-/][a-zA-Z]{3,}[-/]\d{2,4}$/.test(s)) {
          const [d, mon, y] = s.split(/[-/]/);
          const mi = MONTH_MAP[mon.slice(0, 3).toLowerCase()];
          if (mi !== undefined) {
            const year = y.length <= 2 ? 2000 + +y : +y;
            finalDate = new Date(year, mi, +d);
          }
        }
        // last resort: JS native parse (handles RFC 2822, ISO 8601, etc.)
        else {
          const d = new Date(s);
          if (!isNaN(d.getTime())) finalDate = d;
        }
      }

      return finalDate && !isNaN(finalDate.getTime()) ? finalDate : null;
    };

    // Returns normalised "HH:MM:SS"; "24:00" for end-of-day
    const parseExcelTime = (val) => {
      if (val == null || val === "") return "";

      if (typeof val === "number") {
        // Excel time fraction (0–1) or 1.0 for 24:00
        let totalSeconds = Math.round(val * 86400);
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes = Math.floor(totalSeconds / 60);
        if (hours === 24 || val >= 1) return "24:00";
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:00`;
      }

      if (val instanceof Date) {
        return val.toTimeString().split(" ")[0];
      }

      if (typeof val === "string") {
        const str = val.trim();

        // Decimal fraction string e.g. "0", "0.125", "0.9583" (cell with no time format)
        if (/^\d+(\.\d+)?$/.test(str)) {
          const num = parseFloat(str);
          if (num >= 0 && num <= 1.0001) {
            let totalSeconds = Math.round(num * 86400);
            const hours = Math.floor(totalSeconds / 3600);
            totalSeconds %= 3600;
            const minutes = Math.floor(totalSeconds / 60);
            if (hours >= 24) return "24:00";
            return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:00`;
          }
        }

        // "HH:MM" or "HH:MM:SS" string
        const match = str.match(/^(\d{1,2}):(\d{2})/);
        if (match) {
          const h = match[1].padStart(2, "0");
          const m = match[2];
          if (h === "24") return "24:00";
          return `${h}:${m}:00`;
        }
        return str;
      }
      return "";
    };

    // Convert "24:00" / "24:00:00" → "23:59"
    const normaliseEndTime = (t) =>
      t === "24:00" || t === "24:00:00" ? "23:59" : t;

    const getVal = (row, key) =>
      row && row[key] !== undefined ? row[key] : "";

    // Collect ALL unique keys across every row in insertion order.
    // sheetData[0] (tender-values row) may have EMPTY date cells, so its keys
    // list would be incomplete. The bidding/auction label rows always have the
    // C-F column keys populated, so scanning all rows gives the full key set.
    const keysSet = new Set();
    sheetData.forEach((row) => Object.keys(row).forEach((k) => keysSet.add(k)));
    const keys = Array.from(keysSet);

    const findKey = (searchStr) =>
      keys.find((k) =>
        k
          .toLowerCase()
          .replace(/\s/g, "")
          .includes(searchStr.toLowerCase().replace(/\s/g, "")),
      );

    // Map the four date/time column headers from Row 1
    const KEY_T_START_DATE = findKey("Tender Start Date") || keys[2];
    const KEY_T_START_TIME = findKey("Tender Start Time") || keys[3];
    const KEY_T_END_DATE = findKey("Tender End Date") || keys[4];
    const KEY_T_END_TIME = findKey("Tender End Time") || keys[5];

    // Column A = "Reverse Auction" (the A1 header, used for requisition numbers)
    const KEY_COL_A = keys[0];
    // Column B = B1 is empty (merged into A1:B1), so XLSX auto-names it "__EMPTY".
    // This maps to the "Start Date" column in the Requisitions section.
    const KEY_COL_B = keys.find((k) => k === "__EMPTY") || keys[1];

    // --- Locate section rows dynamically ---
    // Tender row: always sheetData[0] (first data row after the header row)
    const tenderRow = sheetData[0] || {};

    // Bidding / Auction label rows: find by scanning ALL cell values for keyword
    const findLabelRow = (keyword) =>
      sheetData.findIndex((row) =>
        Object.values(row).some((v) =>
          String(v || "")
            .toLowerCase()
            .includes(keyword),
        ),
      );

    const biddingLabelIdx = findLabelRow("bidding");
    const biddingRow =
      biddingLabelIdx !== -1
        ? sheetData[biddingLabelIdx + 1] || {}
        : sheetData[2] || {};

    const auctionLabelIdx = findLabelRow("auction");
    const auctionRow =
      auctionLabelIdx !== -1
        ? sheetData[auctionLabelIdx + 1] || {}
        : sheetData[4] || {};

    // Comment row: last row that has "comment" anywhere in its values
    const commentRowIdx = sheetData.reduce((found, row, i) => {
      const hasComment = Object.values(row).some((v) =>
        String(v || "")
          .toLowerCase()
          .includes("comment"),
      );
      return hasComment ? i : found;
    }, -1);
    const commentRow =
      commentRowIdx !== -1
        ? sheetData[commentRowIdx]
        : sheetData[sheetData.length - 1] || {};

    const parsedTenderStartDate = parseExcelDate(
      getVal(tenderRow, KEY_T_START_DATE),
    );
    const parsedTenderStartTime = parseExcelTime(
      getVal(tenderRow, KEY_T_START_TIME),
    );
    const parsedTenderEndDate = parseExcelDate(
      getVal(tenderRow, KEY_T_END_DATE),
    );
    const parsedTenderEndTime = parseExcelTime(
      getVal(tenderRow, KEY_T_END_TIME),
    );

    const parsedBiddingStartDate = parseExcelDate(
      getVal(biddingRow, KEY_T_START_DATE),
    );
    const parsedBiddingStartTime = parseExcelTime(
      getVal(biddingRow, KEY_T_START_TIME),
    );
    const parsedBiddingEndDate = parseExcelDate(
      getVal(biddingRow, KEY_T_END_DATE),
    );
    const parsedBiddingEndTime = parseExcelTime(
      getVal(biddingRow, KEY_T_END_TIME),
    );

    const parsedAuctionStartDate = parseExcelDate(
      getVal(auctionRow, KEY_T_START_DATE),
    );
    const parsedAuctionStartTime = parseExcelTime(
      getVal(auctionRow, KEY_T_START_TIME),
    );
    const parsedAuctionEndDate = parseExcelDate(
      getVal(auctionRow, KEY_T_END_DATE),
    );
    const parsedAuctionEndTime = parseExcelTime(
      getVal(auctionRow, KEY_T_END_TIME),
    );

    const missingFields = [];
    if (!parsedTenderStartDate) missingFields.push("Tender Start Date");
    if (!parsedTenderStartTime) missingFields.push("Tender Start Time");
    if (!parsedTenderEndDate) missingFields.push("Tender End Date");
    if (!parsedTenderEndTime) missingFields.push("Tender End Time");
    if (!parsedBiddingStartDate) missingFields.push("Bidding Start Date");
    if (!parsedBiddingStartTime) missingFields.push("Bidding Start Time");
    if (!parsedBiddingEndDate) missingFields.push("Bidding End Date");
    if (!parsedBiddingEndTime) missingFields.push("Bidding End Time");
    if (!parsedAuctionStartDate) missingFields.push("Auction Start Date");
    if (!parsedAuctionStartTime) missingFields.push("Auction Start Time");
    if (!parsedAuctionEndDate) missingFields.push("Auction End Date");
    if (!parsedAuctionEndTime) missingFields.push("Auction End Time");

    if (missingFields.length > 0) {
      toast.error(
        `Invalid file format — missing: ${missingFields.join(", ")}. Please use the latest template.`,
      );
      // Do NOT reset uploadLock here — the 1-second timeout handles it.
      // Resetting early allows a second sheet's call to run and show a duplicate toast.
      return;
    }

    setTenderStartDate(parsedTenderStartDate);
    setTenderStartTime(parsedTenderStartTime);
    setTenderEndDate(parsedTenderEndDate);
    setTenderEndTime(normaliseEndTime(parsedTenderEndTime));

    setBiddingStartDate(parsedBiddingStartDate);
    setBiddingStartTime(parsedBiddingStartTime);
    setBiddingEndDate(parsedBiddingEndDate);
    setBiddingEndTime(normaliseEndTime(parsedBiddingEndTime));

    setReverseAuctionStartDate(parsedAuctionStartDate);
    setReverseAuctionStartTime(parsedAuctionStartTime);
    setReverseAuctionEndDate(parsedAuctionEndDate);
    setReverseAuctionEndTime(normaliseEndTime(parsedAuctionEndTime));

    // Comment: try column C first, column D as fallback (merged-cell start differs per client)
    setComment(
      getVal(commentRow, KEY_T_START_DATE) ||
        getVal(commentRow, KEY_T_START_TIME) ||
        "NA",
    );

    // Requisitions: find the REQUISITIONS header row then read data rows below it
    const reqHeaderIndex = sheetData.findIndex((row) => {
      const v = getVal(row, KEY_COL_A);
      return v && String(v).toLowerCase().includes("requisition");
    });

    let resList = [];
    if (reqHeaderIndex !== -1) {
      resList = sheetData
        .slice(reqHeaderIndex + 1)
        .filter((row) => getVal(row, KEY_COL_A))
        .map((row) => ({
          startDate: parseExcelDate(getVal(row, KEY_COL_B)) || "",
          endDate: parseExcelDate(getVal(row, KEY_T_START_DATE)) || "",
          startTime: parseExcelTime(getVal(row, KEY_T_START_TIME)),
          endTime: parseExcelTime(getVal(row, KEY_T_END_DATE)),
          quantity: getVal(row, KEY_T_END_TIME) || "",
          minQty: getVal(row, keys[6] || "__EMPTY_1") || "",
        }));
    }

    const filteredReqs = resList.filter(
      (item) => item.startDate !== "" && item.quantity !== "",
    );

    if (filteredReqs.length === 0) {
      toast.error(
        "No valid requisitions found. Please fill at least one requisition row in the template.",
      );
      uploadLock.current = false;
      return;
    }

    setRequisitions(filteredReqs);
    toast.success(
      "Template uploaded successfully. All fields have been populated.",
    );
  };

  const handleExcelUploadRFQ = (sheetData, fileName) => {
    // 1. PREVENT DOUBLE EXECUTION & EMPTY DATA
    if (uploadLock.current || !sheetData || sheetData.length === 0) return;

    uploadLock.current = true;
    setTimeout(() => {
      uploadLock.current = false;
    }, 1000);

    // ---------------------------------------------------------
    // 2. ROBUST HELPERS
    // ---------------------------------------------------------

    // Helper: Convert Excel Serial Date to JS Date
    const excelSerialDateToJSDate = (serial) => {
      if (!serial) return null;
      const msPerDay = 24 * 60 * 60 * 1000;
      const date = new Date(Math.round((serial - 25569) * msPerDay));
      return isNaN(date.getTime()) ? null : date;
    };

    // Helper: Parse Date (CRASH FIX IS HERE)
    const parseExcelDate = (val) => {
      if (!val) return null;

      let finalDate = null;

      // Case A: Already a Date object
      if (val instanceof Date) {
        finalDate = val;
      }
      // Case B: Excel Serial Number
      else if (typeof val === "number") {
        finalDate = excelSerialDateToJSDate(val);
      }
      // Case C: String Parsing
      else {
        const dateString = String(val).trim();

        // 1. Try "YYYY-MM-DD"
        if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [yyyy, mm, dd] = dateString.split("-");
          finalDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        }
        // 2. Try "DD-MM-YYYY" or "DD/MM/YYYY"
        else if (dateString.match(/^\d{1,2}[-/]\d{1,2}[-/]\d{4}$/)) {
          const parts = dateString.includes("-")
            ? dateString.split("-")
            : dateString.split("/");
          const [dd, mm, yyyy] = parts;
          finalDate = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
        }
        // 3. Fallback to standard parser
        else {
          finalDate = new Date(dateString);
        }
      }

      // CRITICAL CHECK: If date is Invalid (NaN), return null to prevent Crash
      if (finalDate && isNaN(finalDate.getTime())) {
        return null;
      }

      return finalDate;
    };

    // Helper: Parse Time
    const parseExcelTime = (val) => {
      if (val === undefined || val === null || val === "") return "";

      // Handle Excel Serial Time (0.5 = 12:00)
      if (typeof val === "number") {
        let totalSeconds = Math.round(val * 86400);
        const hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        const minutes = Math.floor(totalSeconds / 60);
        if (hours === 24) return "24:00";
        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
          2,
          "0",
        )}:00`;
      }

      // Handle Date Object
      if (val instanceof Date) {
        const timeStr = val.toTimeString().split(" ")[0]; // Gets HH:MM:SS
        return timeStr.substring(0, 5); // Extract only HH:MM
      }

      // Handle String
      if (typeof val === "string") {
        const str = val.trim();
        const match = str.match(/(\d{1,2}):(\d{2})/);
        if (match) {
          return `${match[1].padStart(2, "0")}:${match[2]}`;
        }
        return str;
      }
      return "";
    };

    const getVal = (row, key) =>
      row && row[key] !== undefined ? row[key] : "";

    // ---------------------------------------------------------
    // 3. KEY MAPPING
    // ---------------------------------------------------------
    const firstRow = sheetData[0];
    const thirdRow = sheetData[3];
    const keys = Object.keys(firstRow);
    let hasValidationErrors = false;

    const findKey = (searchStr) => {
      return keys.find((k) =>
        k
          .toLowerCase()
          .replace(/\s/g, "")
          .includes(searchStr.toLowerCase().replace(/\s/g, "")),
      );
    };

    // Find keys dynamically
    const KEY_T_START_DATE = findKey("Tender Start Date") || keys[2];
    const KEY_T_START_TIME = findKey("Tender Start Time") || keys[3];
    const KEY_T_END_DATE = findKey("Tender End Date") || keys[4];
    const KEY_T_END_TIME = findKey("Tender End Time") || keys[5];
    const KEY_COL_A = keys[0];
    const KEY_COL_B = keys[1];

    // ---------------------------------------------------------
    // 4. EXTRACT DATA
    // ---------------------------------------------------------
    const tenderRow = sheetData[0] || {};

    const biddingRow = sheetData[2] || {};
    const moneyRow = sheetData[4] || {};

    const commentRow = sheetData[sheetData?.length - 1] || {};

    // ---------------------------------------------------------
    // 4a. VALIDATE REQUIRED FIELDS & DATES
    // ---------------------------------------------------------
    const parsedTenderStartDate = parseExcelDate(
      getVal(tenderRow, KEY_T_START_DATE),
    );
    const parsedTenderStartTime = parseExcelTime(
      getVal(tenderRow, KEY_T_START_TIME),
    );
    const parsedTenderEndDate = parseExcelDate(
      getVal(tenderRow, KEY_T_END_DATE),
    );
    const parsedTenderEndTime = parseExcelTime(
      getVal(tenderRow, KEY_T_END_TIME),
    );
    const parsedBiddingStartDate = parseExcelDate(
      getVal(biddingRow, KEY_T_START_DATE),
    );
    const parsedBiddingStartTime = parseExcelTime(
      getVal(biddingRow, KEY_T_START_TIME),
    );
    const parsedBiddingEndDate = parseExcelDate(
      getVal(biddingRow, KEY_T_END_DATE),
    );
    const parsedBiddingEndTime = parseExcelTime(
      getVal(biddingRow, KEY_T_END_TIME),
    );
    const parsedEmd = getVal(moneyRow, KEY_T_START_TIME);
    const parsedInitialMargin = getVal(moneyRow, KEY_T_END_DATE);
    const parsedPaymentSecurity = getVal(moneyRow, KEY_T_END_TIME);
    const parsedTenderType = String(getVal(moneyRow, KEY_T_START_DATE) || "")
      .trim()
      .toLowerCase();

    // Check missing required fields
    const missingFields = [];
    if (!parsedTenderStartDate) missingFields.push("Tender Start Date");
    if (!parsedTenderStartTime) missingFields.push("Tender Start Time");
    if (!parsedTenderEndDate) missingFields.push("Tender End Date");
    if (!parsedTenderEndTime) missingFields.push("Tender End Time");
    if (!parsedBiddingStartDate) missingFields.push("Bidding Start Date");
    if (!parsedBiddingStartTime) missingFields.push("Bidding Start Time");
    if (!parsedBiddingEndDate) missingFields.push("Bidding End Date");
    if (!parsedBiddingEndTime) missingFields.push("Bidding End Time");
    // if (!parsedEmd && parsedEmd !== 0) missingFields.push("EMD");
    // if (!parsedInitialMargin && parsedInitialMargin !== 0)
    //   missingFields.push("Initial Margin");
    if (!parsedPaymentSecurity && parsedPaymentSecurity !== 0)
      missingFields.push("Payment Security");
    if (
      !parsedTenderType ||
      (parsedTenderType !== "intrastate" && parsedTenderType !== "interstate")
    )
      if (
        !parsedTenderType ||
        (parsedTenderType !== "intrastate" && parsedTenderType !== "interstate")
      ) {
        if (missingFields.length > 0) {
          toast.error("Invalid file format. Please use the latest template.");
          hasValidationErrors = true;
          uploadLock.current = false;
          return;
        }
      }
    if (missingFields.length > 0) {
      // missingFields.push("Tender Type (Intrastate/Interstate)");

      // toast.info(
      //   `Some fields are missing in the template: ${missingFields.join(", ")}`,
      //   toastProperties,
      // );
      toast.error("Invalid file format. Please use the latest template.");
    }

    // if (fileName) {

    //     fileName.match(/(\d{2})[-/](\d{2})[-/](\d{4})/) ||
    //     fileName.match(/(\d{4})[-/](\d{2})[-/](\d{2})/);

    //   if (fileNameDateMatch) {
    //     let fileDate;
    //     if (fileNameDateMatch[1].length === 4) {
    //       fileDate = new Date(
    //         Number(fileNameDateMatch[1]),
    //         Number(fileNameDateMatch[2]) - 1,
    //         Number(fileNameDateMatch[3]),
    //       );
    //     } else {
    //       fileDate = new Date(
    //         Number(fileNameDateMatch[3]),
    //         Number(fileNameDateMatch[2]) - 1,
    //         Number(fileNameDateMatch[1]),
    //       );
    //     }

    //     if (fileDateStr !== todayStr) {
    //       toast.error(
    //         `Template file is dated ${fileDateStr}. Please upload today's template (${todayStr}).`,
    //         toastProperties,
    //       );
    //       return;
    //     }
    // }

    // --- Tender ---
    setTenderStartDate(parsedTenderStartDate);
    setTenderStartTime(parsedTenderStartTime);
    setTenderEndDate(parsedTenderEndDate);
    setTenderEndTime(parsedTenderEndTime);

    // --- Tender Type (Intrastate = CLOSED, Interstate = OPEN) ---
    if (parsedTenderType === "intrastate") {
      handleTenderType("CLOSED");
    } else if (parsedTenderType === "interstate") {
      handleTenderType("OPEN");
    }

    // --- Bidding ---
    setBiddingStartDate(parsedBiddingStartDate);
    setBiddingStartTime(parsedBiddingStartTime);
    setBiddingEndDate(parsedBiddingEndDate);
    setBiddingEndTime(parsedBiddingEndTime);

    // --- Money & Comments ---
    // Column mapping: KEY_T_START_DATE=TenderType, KEY_T_START_TIME=EMD, KEY_T_END_DATE=InitialMargin, KEY_T_END_TIME=PaymentSecurity
    setEmd(parsedEmd);
    setInitialMargin(parsedInitialMargin * 100);
    setPaymentSecurity(parsedPaymentSecurity);
    setComment(getVal(commentRow, KEY_T_START_DATE) || "NA");

    // --- Requisitions ---
    const reqHeaderIndex = sheetData.findIndex((row) => {
      const val = getVal(row, KEY_COL_A);
      return val && String(val).toLowerCase().includes("requisition");
    });

    let resList = [];
    if (reqHeaderIndex !== -1) {
      const reqRows = sheetData.slice(reqHeaderIndex + 1);

      resList = reqRows
        .filter((row) => getVal(row, KEY_COL_A))
        .map((row) => ({
          startDate: parseExcelDate(getVal(row, KEY_COL_B)) || "",
          endDate: parseExcelDate(getVal(row, KEY_T_START_DATE)) || "",
          startTime: parseExcelTime(getVal(row, KEY_T_START_TIME)),
          endTime: parseExcelTime(getVal(row, KEY_T_END_DATE)),
          quantity: getVal(row, KEY_T_END_TIME) || "",
          minQty: getVal(row, keys[6] || "__EMPTY_1") || "",
        }));
    }

    setRequisitions(
      resList.filter((item) => item.startDate !== "" && item.quantity !== ""),
    );
    if (!hasValidationErrors) {
      toast.success(
        "Template uploaded successfully. All fields have been populated.",
      );
    }
  };

  const handleValidateError = () => {
    const newErrors = {};
    const now = new Date();

    // 1. Time Rule Constants (in hours)
    const RULES = {
      TENDER_START_OFFSET: 1,
      TENDER_MIN_DURATION: 48,
      BID_START_AFTER_TENDER_START: 1,
      BID_MIN_DURATION: 2,
      RFQ_BID_BEFORE_TENDER_END: 4,
      NON_RFQ_BID_START_BEFORE_TENDER_END: 8,
      NON_RFQ_BID_END_BEFORE_TENDER_END: 6,
      RA_START_AFTER_BID_END: 2,
      RA_START_BEFORE_TENDER_END: 6,
      RA_MIN_DURATION: 2,
      RA_END_BEFORE_TENDER_END: 4,
      REQ_GAP_AFTER_TENDER_END: 48,
    };

    // 2. Helper to create Date objects
    const createDate = (date, time) => {
      if (!date || !time) return null;
      const newDate = new Date(date);
      const [hours, minutes] = time.split(":").map(Number);
      if (isNaN(newDate.getTime()) || isNaN(hours) || isNaN(minutes))
        return null;
      newDate.setHours(hours, minutes, 0, 0);
      return newDate;
    };

    // 3. Normalized Date Objects
    const tStart = createDate(tenderStartDate, tenderStartTime);
    const tEnd = createDate(tenderEndDate, tenderEndTime);
    const bStart = createDate(biddingStartDate, biddingStartTime);
    const bEnd = createDate(biddingEndDate, biddingEndTime);
    const raStart = createDate(
      reverseAuctionStartDate,
      reverseAuctionStartTime,
    );
    const raEnd = createDate(reverseAuctionEndDate, reverseAuctionEndTime);

    // --- REQUISITION VALIDATIONS ---
    requisitions.forEach((req, idx) => {
      if (!req.startDate)
        newErrors[`startDate_${idx}`] = "Start Date is required";
      if (!req.endDate) newErrors[`endDate_${idx}`] = "End Date is required";
      if (!req.startTime)
        newErrors[`startTime_${idx}`] = "Start Time is required";
      if (!req.endTime) newErrors[`endTime_${idx}`] = "End Time is required";
      if (!req.quantity)
        newErrors[`quantity_${idx}`] = "Req. Quantity is required";
      if (!req.minQty) newErrors[`minQty_${idx}`] = "Min. Quantity is required";

      const rStart = createDate(req.startDate, req.startTime);
      const rEnd = createDate(req.endDate, req.endTime);

      if (rStart && rEnd) {
        if (rEnd <= rStart)
          newErrors[`endTime_${idx}`] =
            "End Time must be greater than Start Time";
        // Requisition Common Rule: 48 hours after tender end
        if (
          tEnd &&
          rStart <
            new Date(tEnd.getTime() + RULES.REQ_GAP_AFTER_TENDER_END * 3600000)
        ) {
          newErrors[`startDate_${idx}`] =
            `Must be minimum ${RULES.REQ_GAP_AFTER_TENDER_END} hours after Tender End`;
        }
      }
    });

    // --- MANDATORY FIELDS ---
    if (!tenderStartDate)
      newErrors.tenderStartDate = "Tender Start Date is required";
    if (!tenderStartTime)
      newErrors.tenderStartTime = "Tender Start Time is required";
    if (!tenderEndDate) newErrors.tenderEndDate = "Tender End Date is required";
    if (!tenderEndTime) newErrors.tenderEndTime = "Tender End Time is required";
    if (!biddingStartDate)
      newErrors.biddingStartDate = "Bidding Start Date is required";
    if (!biddingStartTime)
      newErrors.biddingStartTime = "Bidding Start Time is required";
    if (!biddingEndDate)
      newErrors.biddingEndDate = "Bidding End Date is required";
    if (!biddingEndTime)
      newErrors.biddingEndTime = "Bidding End Time is required";

    if (!rfq) {
      if (!reverseAuctionStartDate)
        newErrors.reverseAuctionStartDate = "Auction Start Date is required";
      if (!reverseAuctionStartTime)
        newErrors.reverseAuctionStartTime = "Auction Start Time is required";
      if (!reverseAuctionEndDate)
        newErrors.reverseAuctionEndDate = "Auction End Date is required";
      if (!reverseAuctionEndTime)
        newErrors.reverseAuctionEndTime = "Auction End Time is required";
    }

    // --- LOGIC RULES ---

    // Tender Rules
    if (tStart) {
      if (
        tStart < new Date(now.getTime() + RULES.TENDER_START_OFFSET * 3600000)
      ) {
        newErrors.tenderStartTime = `Must be at least ${RULES.TENDER_START_OFFSET} hour from now`;
      }
      if (
        tEnd &&
        tEnd < new Date(tStart.getTime() + RULES.TENDER_MIN_DURATION * 3600000)
      ) {
        newErrors.tenderEndDate = `Must be minimum ${RULES.TENDER_MIN_DURATION} hours after Tender Start`;
      }
    }

    if (rfq) {
      // IF RFQ === TRUE
      if (
        bStart &&
        tStart &&
        bStart <
          new Date(
            tStart.getTime() + RULES.BID_START_AFTER_TENDER_START * 3600000,
          )
      ) {
        newErrors.biddingStartDate = `Must be min ${RULES.BID_START_AFTER_TENDER_START} hour after Tender Start`;
      }
      if (
        bStart &&
        tEnd &&
        bStart >
          new Date(tEnd.getTime() - RULES.RFQ_BID_BEFORE_TENDER_END * 3600000)
      ) {
        newErrors.biddingStartDate = `Must be at least ${RULES.RFQ_BID_BEFORE_TENDER_END} hours before Tender End`;
      }
      if (
        bEnd &&
        bStart &&
        bEnd < new Date(bStart.getTime() + RULES.BID_MIN_DURATION * 3600000)
      ) {
        newErrors.biddingEndDate = `Must be min ${RULES.BID_MIN_DURATION} hours after Bidding Start`;
      }
      if (bEnd && tEnd && bEnd > new Date(tEnd.getTime() - 2 * 3600000)) {
        newErrors.biddingEndDate = "Must be at least 2 hours before Tender End";
      }
    } else {
      // IF RFQ === FALSE
      if (
        bStart &&
        tStart &&
        bStart <
          new Date(
            tStart.getTime() + RULES.BID_START_AFTER_TENDER_START * 3600000,
          )
      ) {
        newErrors.biddingStartDate = `Must be min ${RULES.BID_START_AFTER_TENDER_START} hour after Tender Start`;
      }
      if (
        bStart &&
        tEnd &&
        bStart >
          new Date(
            tEnd.getTime() -
              RULES.NON_RFQ_BID_START_BEFORE_TENDER_END * 3600000,
          )
      ) {
        newErrors.biddingStartDate = `Must be at least ${RULES.NON_RFQ_BID_START_BEFORE_TENDER_END} hours before Tender End`;
      }
      if (
        bEnd &&
        bStart &&
        bEnd < new Date(bStart.getTime() + RULES.BID_MIN_DURATION * 3600000)
      ) {
        newErrors.biddingEndDate = `Must be min ${RULES.BID_MIN_DURATION} hours after Bidding Start`;
      }
      if (
        bEnd &&
        tEnd &&
        bEnd >
          new Date(
            tEnd.getTime() - RULES.NON_RFQ_BID_END_BEFORE_TENDER_END * 3600000,
          )
      ) {
        newErrors.biddingEndDate = `Must be at least ${RULES.NON_RFQ_BID_END_BEFORE_TENDER_END} hours before Tender End`;
      }

      // Reverse Auction Logic
      if (
        raStart &&
        bEnd &&
        raStart <
          new Date(bEnd.getTime() + RULES.RA_START_AFTER_BID_END * 3600000)
      ) {
        newErrors.reverseAuctionStartDate = `Must be min ${RULES.RA_START_AFTER_BID_END} hours after Bidding End`;
      }
      if (
        raStart &&
        tEnd &&
        raStart >
          new Date(tEnd.getTime() - RULES.RA_START_BEFORE_TENDER_END * 3600000)
      ) {
        newErrors.reverseAuctionStartDate = `Must be at least ${RULES.RA_START_BEFORE_TENDER_END} hours before Tender End`;
      }
      if (
        raEnd &&
        raStart &&
        raEnd < new Date(raStart.getTime() + RULES.RA_MIN_DURATION * 3600000)
      ) {
        newErrors.reverseAuctionEndDate = `Must be min ${RULES.RA_MIN_DURATION} hours after Auction Start`;
      }
      if (
        raEnd &&
        tEnd &&
        raEnd >
          new Date(tEnd.getTime() - RULES.RA_END_BEFORE_TENDER_END * 3600000)
      ) {
        newErrors.reverseAuctionEndDate = `Must be at least ${RULES.RA_END_BEFORE_TENDER_END} hours before Tender End`;
      }
    }

    // Miscellaneous
    if (!initialMargin) newErrors.initialMargin = "Initial Margin is required";
    if (!(Emd || Emd === 0)) newErrors.emd = "EMD is required";
    if (!paymentSecurity)
      newErrors.paymentSecurity = "Payment Security is required";

    if (
      tenderType === "CLOSED" &&
      defData?.length + (editClosed?.length || 0) < 3
    ) {
      toast.error(
        "Minimum 3 Generator required for the Closed Auction type",
        toastProperties,
      );
      handleselectionModalMain("gen");
      newErrors.defData = "Minimum 3 Generator required";
    }

    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRequirementChange = (index, field, value) => {
    setRequisitions(
      requisitions.map((req, i) =>
        i === index ? { ...req, [field]: value } : req,
      ),
    );
  };
  const convertEndTimeFormat = (timeString) => {
    return timeString === "24:00" ? "23:59" : timeString;
  };

  const handleAddRequirement = () => {
    setRequisitions([
      ...requisitions,
      {
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        quantity: "",
        minQty: "",
      },
    ]);
  };

  const handleRemoveRequirement = (index) => {
    if (requisitions?.length === 1) return;
    setRequisitions(requisitions.filter((_, i) => i !== index));
  };

  const handleTenderType = async (type) => {
    if (type === "CLOSED") {
      let res = await getSelfGenerators(
        stateId,
        user === "CONSUMER" ? "generatorDetails" : "consumerDetails",
      );
      if (res?.data?.code === 200) {
        setDefData(res?.data?.data?.map((ele) => ele.id) || []);
      }
    }
    if (type === "OPEN") {
      setDefData([]);
    }

    setTenderType(type);
  };

  const handleTcm = (type) => {
    setTcm(type);
  };

  const handleFormSubmit = async () => {
    if (!tenderData?.id && !acceptSystemTerms)
      return ErrorMessage("Please accept Terms and Conditions.");
    if (!handleValidateError()) return;
    if (!paymentConfigurationId && !paymentConfigurationIdBil) {
      toast.error(
        "Payment is not Configured for this user. Please contact admin.",
        toastProperties,
      );
      return;
    }
    setLoading(true);
    setIsSubmitting(true);
    dispatch(activeType2Loading(true));
    setTimeout(() => {
      setIsSubmitting(false);
    }, 2000);
    if (type === "edit" && !duplicate) {
      let updatePayload = {
        traderAssigned: isTrader?.roles?.includes("TRADER")
          ? isTrader?.user?.user?.userId
          : 0,
        id: tenderData?.capacityId,
        initialMargin: 100,
        emd: 0,
        paymentSecurity: 4,
        tenderDoc: generalTC,
        comments: comment,
        paymentConfigurationId:
          paymentConfigurationId || paymentConfigurationIdBil,
        slots: requisitions?.map((ele) => ({
          dateStartAt: formatDateElement(ele?.startDate),
          dateEndAt: formatDateElement(ele?.endDate),
          slotStartAt: ele?.startTime,
          slotEndAt: ele?.endTime === "24:00" ? "23:59" : ele?.endTime,
          requiredQty: Number(ele?.quantity),
          landingCost: Number(ele?.price),
          purchaseEnergy: Number(ele?.quantity),
          energyRateStr: "",
          minimumQty: Number(ele?.minQty),
        })),
      };
      let res = await editListing(
        updatePayload,
        user === "CONSUMER" ? "consumer" : "generator",
      );
      if (res?.data?.code === 200) {
        updateTender();
      }
      setLoading(false);
      dispatch(activeType2Loading(false));
      return;
    }
    let capacityPayload = {
      energySourceType: "Any",
      energyFuelType: "Any",
      traderAssigned: isTrader?.roles?.includes("TRADER")
        ? isTrader?.user?.user?.userId
        : 0,
      slots: requisitions?.map((ele) => ({
        dateStartAt: formatDateElement(ele?.startDate),
        dateEndAt: formatDateElement(ele?.endDate),
        slotStartAt: `${ele?.startTime?.split(":")?.[0]}:${
          ele?.startTime?.split(":")?.[1]
        }`,
        slotEndAt:
          ele?.endTime === "24:00" || ele?.endTime === "24:00:00"
            ? "23:59"
            : `${ele?.endTime?.split(":")?.[0]}:${
                ele?.endTime?.split(":")?.[1]
              }`,
        requiredQty: Number(ele?.quantity),
        landingCost: Number(ele?.price) || 1,
        purchaseEnergy: Number(ele?.quantity),
        energyRateStr: "",
        minimumQty: Number(ele?.minQty),
      })),
      isInterstate: true,
      lcVersionId: 3,
      isBilateral: false,
      listingMode: listingMode,
      matchingTags: "Solar,Noon,Hot",
      voltageLevel: "132kV",
      listingExpDate: formatDateElement(tenderEndDate),
      listingExpTime: `${tenderEndTime?.split(":")?.[0]}:${
        tenderEndTime?.split(":")?.[1]
      }`,
      paymentConfigurationId:
        paymentConfigurationId || paymentConfigurationIdBil,
      region: "Northern",
      initialMargin: 100,
      emd: 0,
      paymentSecurity: 4,
      termsExpDate: formatDateElement(tenderEndDate),
      termsExpTime: `${tenderEndTime?.split(":")?.[0]}:${
        tenderEndTime?.split(":")?.[1]
      }`,
      comment: comment,
      termsDocumentId: null,
      listingType: "GREATER_THAN_SEVEN_DAYS",
    };

    let res = await createListing(
      capacityPayload,
      user === "CONSUMER" ? "consumer" : "generator",
    );
    if (res?.data?.code === 200) {
      createTender(res?.data?.data?.id);
    }
    setLoading(false);
    dispatch(activeType2Loading(false));
  };

  const createTender = async (capId) => {
    let tenderPayload = {
      traderAssigned: isTrader?.roles?.includes("TRADER")
        ? isTrader?.user?.user?.userId
        : 0,
      tenderType: rfq ? "CB" : "RA",
      auctionType: tenderType === "CLOSED" ? "CLOSED" : "OPEN",
      capacityId: capId,
      tenderStartDateTime: `${formatDateElement(
        tenderStartDate,
      )} ${tenderStartTime}`,
      tenderCloseDateTime: `${formatDateElement(
        tenderEndDate,
      )} ${convertEndTimeFormat(tenderEndTime)}`,
      bidStartDateTime: `${formatDateElement(
        biddingStartDate,
      )} ${biddingStartTime}`,
      bidCloseDateTime: `${formatDateElement(
        biddingEndDate,
      )} ${convertEndTimeFormat(biddingEndTime)}`,
      auctionStartDateTime: reverseAuctionStartDate
        ? `${formatDateElement(
            reverseAuctionStartDate,
          )} ${reverseAuctionStartTime}`
        : null,
      auctionCloseDateTime: reverseAuctionEndDate
        ? `${formatDateElement(reverseAuctionEndDate)} ${convertEndTimeFormat(reverseAuctionEndTime)}`
        : null,
      bidQuantityIncrement: 0,
      bidPriceIncrement: 0,
      bidPriceDecrement: 0,
      emdPerMw: Emd,
      ipoDateTime: `${formatDateElement(biddingEndDate)} ${convertEndTimeFormat(biddingEndTime)}`,
      paymentSecurityDays: paymentSecurity,
      initialMarginPercent: initialMargin,
      tenderDoc: generalTC,
      comments: comment,
      productType: "BSRA",
    };

    let res = await createAuctionTender(tenderPayload);
    if (res?.data?.code === 200) {
      setLoading(false);

      if (tenderType === "CLOSED") {
        handleUserSelection(res?.data?.data?.id);
      } else {
        dispatch(auctionGet());
        dispatch(activeType2Loading(false));
        handleClose();
      }
    }
    dispatch(activeType2Loading(false));
    setLoading(false);
  };

  const handleUserSelection = async (id) => {
    let payload = {
      participantIds:
        editClosed?.length > 0 && type === "edit" ? editClosed : defData,
    };
    let res = await handleInviteParticipants(id, payload);
    if (res?.data?.code === 200) {
      dispatch(auctionGet());
      dispatch(activeType2Loading(false));
      handleClose();
    } else {
      setLoading(false);
      dispatch(activeType2Loading(false));
    }
  };

  const updateTender = async () => {
    let tenderPayload = {
      tenderStartDateTime: `${formatDateElement(
        tenderStartDate,
      )} ${tenderStartTime}`,
      tenderCloseDateTime: `${formatDateElement(
        tenderEndDate,
      )} ${convertEndTimeFormat(tenderEndTime)}`,
      bidStartDateTime: `${formatDateElement(
        biddingStartDate,
      )} ${biddingStartTime}`,
      bidCloseDateTime: `${formatDateElement(
        biddingEndDate,
      )} ${convertEndTimeFormat(biddingEndTime)}`,
      auctionStartDateTime:
        reverseAuctionStartDate &&
        `${formatDateElement(
          reverseAuctionStartDate,
        )} ${reverseAuctionStartTime}`,
      auctionCloseDateTime:
        reverseAuctionEndDate &&
        `${formatDateElement(reverseAuctionEndDate)} ${convertEndTimeFormat(reverseAuctionEndTime)}`,
      emdPerMw: Emd,
      ipoDateTime: `${formatDateElement(biddingEndDate)} ${convertEndTimeFormat(biddingEndTime)}`,
      auctionType: tenderType === "CLOSED" ? "CLOSED" : "OPEN",
      tenderDoc: generalTC,
    };

    let res = await updateAuctionTender(tenderPayload, tenderData?.id);
    if (res?.data?.code === 200) {
      if (tenderType === "CLOSED") {
        if (type === "edit") {
          if (editClosed?.length > 0) {
            handleUserSelection(res?.data?.data?.id);
          }

          dispatch(auctionGet());
          dispatch(activeType2Loading(false));
          handleClose();
        } else {
          handleUserSelection(res?.data?.data?.id);
        }
      } else {
        dispatch(auctionGet());
        dispatch(activeType2Loading(false));
        handleClose();
      }
    }
  };

  const handleSelectList = (id) => {
    if (type === "edit") {
      setEditClosed((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
      );
    } else {
      setDefData((prev) =>
        prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
      );
    }
  };

  const handleselectionModalMain = (type) => {
    if (type === "tcm") {
    }
    if (type === "gen") {
      generatorList();
    }
  };

  const generatorList = async () => {
    let res = await getAllGenerators();
    if (res?.data) {
      setSelModalData(res?.data);
      setTimeout(() => {
        setSelectModal(true);
      }, 1000);
    }
  };

  // Helper to add days to a date
  const addDays = (date, days) => {
    if (!date) return "";
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  const handleTerminate = async () => {
    dispatch(activeType2Loading(true));
    let res = await terminateTender({}, tenderData?.id);
    if (res?.data?.code === 200) {
      handleClose();
      dispatch(activeType2Loading(false));
    } else {
      dispatch(activeType2Loading(false));
      ErrorMessage(res?.data?.message);
    }
  };

  const handleActivateModal = () => {
    setConfirmText(`Do you want to withdraw this tender?`);
    setConfirmHeader("Withdraw Tender");
    setConfirmModal(true);
  };

  const handleAuctionTypeSwitch = (type) => {
    if (tenderType === type) return;
    setPendingType(type);
    setSwitchTypeModal(true);
  };

  const handleSwitchTypeConfirm = () => {
    if (pendingType === "CLOSED") {
      setDefData([10, 11, 12, 14, 15]);
    } else {
      setDefData([]);
    }
    handleTenderType(pendingType);
    setSwitchTypeModal(false);
    setPendingType(null);
  };

  const handleRemoveParticipant = (id) => {
    setParticipants(participants?.filter((ele) => ele !== id));
  };

  return (
    <>
      <PdfPreviewModal />
      <ConfirmationModal
        open={confirmModal}
        handleClose={() => setConfirmModal(false)}
        data={confirmText}
        header={confirmHeader}
        handleSubmit={handleTerminate}
      />
      <ConfirmationModal
        open={switchTypeModal}
        handleClose={() => {
          setSwitchTypeModal(false);
          setPendingType(null);
        }}
        data={
          <>
            Are you sure you want to switch to{" "}
            <strong style={{ color: "#34656d" }}>
              {pendingType === "CLOSED" ? "Closed" : "Open"} Auction
            </strong>
            ?
          </>
        }
        header={"Switch Auction Type"}
        handleSubmit={handleSwitchTypeConfirm}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <>
          {selectModal && (
            <SelectParticipant
              open={selectModal}
              handleClose={() => setSelectModal(false)}
              list={selModalData}
              selected={defData}
              header={selcHeader}
              handleSelectList={handleSelectList}
              editType={type === "edit"}
              editClosed={editClosed}
              tenderId={editData?.id}
              participants={participants}
              duplicate={duplicate}
              handleRemoveParticipant={handleRemoveParticipant}
            />
          )}
          <div className={`popupModal ${Styles.tenderModal}`}>
            <div
              className={`display_flex_row modalHeading ${Styles.modalHeading}`}
            >
              <div className="headingText">
                {type === "create"
                  ? "Create"
                  : duplicate
                    ? "Duplicate"
                    : "Edit"}{" "}
                Tender
              </div>
              <Close
                style={{
                  fontSize: "24px",
                  color: "#777777",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              />
            </div>
            <div
              className={`display_flex_column_gap_8 scroll_bar_y ${Styles.tenderInputContianer}`}
            >
              <div className={`display_flex_row ${Styles.excel_upload_main}`}>
                <div
                  className={Styles.fileUploadTemplate}
                  style={{ cursor: "pointer" }}
                >
                  <Fileupload
                    accept={".xlsx"}
                    value={excelUpload}
                    onChange={(sheetData, fileName) =>
                      rfq
                        ? handleExcelUploadRFQ(sheetData, fileName)
                        : handleExcelUploadRA(sheetData, fileName)
                    }
                    example={"Upload Template"}
                    fileType={"excel"}
                    id={"excel-upload"}
                    viewType={2}
                    height={35}
                  />
                </div>
                <div
                  onClick={() => handleDownloadExcel()}
                  className={Styles.excel_down_button}
                >
                  <img src={FileDownloadIcon} alt="" />
                  <span style={{ textWrap: "nowrap" }}>Template</span>
                </div>
              </div>

              <div className={`display_flex_row ${Styles.tendersection}`}>
                <div
                  className={`display_flex_row_center ${Styles.sectionHeading}`}
                >
                  Tender Process
                </div>

                {/* Start Date */}
                <div>
                  <AuctionDateInput
                    heading={"Start Date"}
                    value={tenderStartDate}
                    onChange={(value) => handleTenderStartDate(value)}
                    minDate={
                      // If current time is 10 PM (22:00) or later, start date must be tomorrow
                      new Date().getHours() >= 22
                        ? addDays(new Date(), 1)
                        : new Date()
                    }
                    error={error?.tenderStartDate}
                  />
                </div>

                {/* Start Time */}
                <div>
                  <AuctionTimeInput
                    type={"startTime"}
                    heading={"Start Time"}
                    value={tenderStartTime}
                    onChange={(value) => handleTenderStartTime(value)}
                    startDate={tenderStartDate}
                    error={error?.tenderStartTime}
                    minHr={0}
                    startHours={
                      // Manual check: is tenderStartDate the same as today?
                      new Date(tenderStartDate).toDateString() ===
                      new Date().toDateString()
                        ? new Date().getHours() + 2
                        : 0
                    }
                    startMinutes={0}
                  />
                </div>

                {/* End Date */}
                <div>
                  <AuctionDateInput
                    heading={"End Date"}
                    value={tenderEndDate}
                    onChange={(value) => handleTenderEndDate(value)}
                    // End date must be at least 2 days after start date
                    minDate={addDays(tenderStartDate, 2)}
                    error={error?.tenderEndDate}
                  />
                </div>

                {/* End Time */}
                <div>
                  <AuctionTimeInput
                    type={"endTime"}
                    heading={"End Time"}
                    value={tenderEndTime === "23:59" ? "24:00" : tenderEndTime}
                    onChange={(value) =>
                      handleTenderEndTime(value === "24:00" ? "23:59" : value)
                    }
                    startDate={tenderEndDate}
                    startHours={
                      new Date(tenderEndDate)?.toDateString() ===
                      addDays(new Date(tenderStartDate), 2)?.toDateString()
                        ? Number(tenderStartTime?.split(":")?.[0]) || 0
                        : 0
                    }
                    error={error?.tenderEndTime}
                  />
                </div>
              </div>
              <div className={`display_flex_row ${Styles.tendersection}`}>
                <div
                  className={`display_flex_row_center ${Styles.sectionHeading}`}
                >
                  IPO Submission
                </div>
                <div>
                  <AuctionDateInput
                    heading={"Start Date"}
                    value={biddingStartDate}
                    onChange={(value) => handleBiddingStartDate(value)}
                    minDate={
                      Number(tenderStartTime?.split(":")?.[0]) === 23 &&
                      Number(tenderStartTime?.split(":")?.[1]) >= 45
                        ? addDays(tenderStartDate, 1)
                        : tenderStartDate
                    }
                    height={35}
                    error={error?.biddingStartDate}
                    maxDate={tenderEndDate}
                    disabled={!(tenderStartDate && tenderEndDate)}
                  />
                </div>
                <div>
                  <AuctionTimeInput
                    type={"startTime"}
                    heading={"Start Time"}
                    value={biddingStartTime}
                    onChange={(value) => handleBiddingStartTime(value)}
                    startDate={biddingStartDate}
                    startHours={
                      checkAreSame(biddingStartDate, tenderStartDate)
                        ? Number(tenderStartTime?.split(":")?.[1]) >= 45
                          ? Number(tenderStartTime?.split(":")?.[0]) + 2
                          : Number(tenderStartTime?.split(":")?.[0]) + 1
                        : 0
                    }
                    startMinutes={
                      checkAreSame(biddingStartDate, tenderStartDate) &&
                      Number(biddingStartTime?.split(":")[0]) ===
                        Number(tenderStartTime?.split(":")[0])
                        ? Number(tenderStartTime?.split(":")[1])
                        : 0
                    }
                    error={error?.biddingStartTime}
                  />
                </div>
                <div>
                  <AuctionDateInput
                    heading={"End Date"}
                    value={biddingEndDate}
                    onChange={(value) => handleBiddingEndDate(value)}
                    error={error?.biddingEndDate}
                    minDate={
                      Number(biddingStartTime?.split(":")?.[0]) >= 22
                        ? addDays(biddingStartDate, 1)
                        : biddingStartDate
                    }
                    maxDate={tenderEndDate}
                    disabled={
                      !(tenderStartDate && tenderEndDate && biddingStartDate)
                    }
                  />
                </div>
                <div>
                  <AuctionTimeInput
                    type={"endTime"}
                    heading={"End Time"}
                    value={
                      biddingEndTime === "23:59" ? "24:00" : biddingEndTime
                    }
                    onChange={(value) =>
                      handleBiddingEndTime(value === "24:00" ? "23:59" : value)
                    }
                    startDate={biddingEndDate}
                    error={error?.biddingEndTime}
                    startHours={
                      checkAreSame(biddingEndDate, biddingStartDate)
                        ? Number(biddingStartTime?.split(":")?.[0]) + 2
                        : 0
                    }
                    startMinutes={
                      checkAreSame(biddingEndDate, biddingStartDate) &&
                      Number(biddingEndTime?.split(":")[0]) ===
                        Number(biddingStartTime?.split(":")[0]) + 2
                        ? Number(biddingStartTime?.split(":")[1])
                        : 0
                    }
                  />
                </div>
              </div>
              {!rfq && (
                <div className={`display_flex_row ${Styles.tendersection}`}>
                  <div
                    className={`display_flex_row_center ${Styles.sectionHeading}`}
                  >
                    Reverse Auction
                  </div>
                  <div>
                    <AuctionDateInput
                      heading={"Start Date"}
                      value={reverseAuctionStartDate}
                      onChange={(value) => handleReverseAuctionStartDate(value)}
                      minDate={
                        Number(biddingEndTime?.split(":")?.[0]) >= 22
                          ? addDays(biddingEndDate, 1)
                          : biddingEndDate
                      }
                      maxDate={tenderEndDate}
                      error={error?.reverseAuctionStartDate}
                      disabled={
                        !(tenderStartDate && tenderEndDate && biddingEndDate)
                      }
                    />
                  </div>
                  <div>
                    <AuctionTimeInput
                      type={"startTime"}
                      heading={"Start Time"}
                      value={reverseAuctionStartTime}
                      onChange={(value) => handleReverseAuctionStartTime(value)}
                      startDate={reverseAuctionStartDate}
                      error={error?.reverseAuctionStartTime}
                      startHours={
                        checkAreSame(reverseAuctionStartDate, biddingEndDate)
                          ? Number(biddingEndTime?.split(":")?.[0]) + 2
                          : 0
                      }
                      startMinutes={0}
                    />
                  </div>
                  <div>
                    <AuctionDateInput
                      heading={"End Date"}
                      value={reverseAuctionEndDate}
                      maxDate={tenderEndDate}
                      onChange={(value) => handleReverseAuctionEndDate(value)}
                      height={35}
                      error={error?.reverseAuctionEndDate}
                      minDate={
                        Number(reverseAuctionStartTime?.split(":")?.[0]) >= 22
                          ? addDays(reverseAuctionStartDate, 1)
                          : reverseAuctionStartDate
                      }
                      disabled={
                        !(
                          tenderStartDate &&
                          tenderEndDate &&
                          reverseAuctionStartDate
                        )
                      }
                    />
                  </div>
                  <div>
                    <AuctionTimeInput
                      type={"endTime"}
                      heading={"End Time"}
                      value={
                        reverseAuctionEndTime === "23:59"
                          ? "24:00"
                          : reverseAuctionEndTime
                      }
                      onChange={(value) =>
                        handleReverseAuctionEndTime(
                          value === "24:00" ? "23:59" : value,
                        )
                      }
                      startDate={reverseAuctionEndDate}
                      error={error?.reverseAuctionEndTime}
                      startHours={
                        checkAreSame(
                          reverseAuctionEndDate,
                          reverseAuctionStartDate,
                        )
                          ? Number(reverseAuctionStartTime?.split(":")?.[0]) + 2
                          : 0
                      }
                      startMinutes={0}
                    />
                  </div>
                </div>
              )}
              <div
                className={`display_flex_row_gap_8_only ${Styles.noteContainer}`}
              >
                <b>Note:</b>
                <span>
                  The Requisition (Delivery) Start Date/Time must be at least 48
                  hours after the Tender End Date/Time.
                </span>
              </div>

              {requisitions?.map((ele, index) => {
                // Normalise to "HH:MM" so Excel-parsed "00:00:00" matches "00:00"
                const rtcStart = String(ele?.startTime || "").substring(0, 5);
                const rtcEnd = String(ele?.endTime || "").substring(0, 5);
                let isRtc =
                  rtcStart === "00:00" &&
                  (rtcEnd === "23:59" || rtcEnd === "24:00");
                return (
                  <div
                    className={`display_flex_row ${Styles.tenderRequisitions}`}
                    key={index}
                  >
                    <div
                      className={`display_flex_row_center ${Styles.sectionHeading}`}
                    >
                      Requisition {index + 1}
                    </div>
                    <div>
                      <DateInput
                        heading={"Start Date"}
                        value={requisitions[index]?.startDate}
                        onChange={(value) =>
                          handleRequirementChange(index, "startDate", value)
                        }
                        minDate={
                          Number(tenderEndTime?.split(":")?.[0]) >= 22
                            ? addDays(tenderEndDate, 3)
                            : addDays(tenderEndDate, 3)
                        }
                        height={35}
                        error={error[`startDate_${index}`]}
                        disabled={!(tenderStartDate && tenderEndDate)}
                      />
                    </div>
                    <div>
                      <DateInput
                        heading={"End Date"}
                        value={requisitions[index]?.endDate}
                        onChange={(value) =>
                          handleRequirementChange(index, "endDate", value)
                        }
                        minDate={requisitions[index]?.startDate}
                        height={35}
                        error={error[`endDate_${index}`]}
                        disabled={
                          !(
                            tenderStartDate &&
                            tenderEndDate &&
                            requisitions[index]?.startDate
                          )
                        }
                      />
                    </div>
                    <div>
                      <TimeInput
                        type={"startTime"}
                        heading={"Start Time"}
                        value={requisitions[index]?.startTime}
                        onChange={(value) =>
                          handleRequirementChange(index, "startTime", value)
                        }
                        startDate={requisitions[index]?.startDate}
                        minutesStep={15}
                        height={35}
                        error={error[`startTime_${index}`]}
                        noTooltip={true}
                        rtcButton={true}
                        endTime={requisitions[index]?.endTime}
                        handleRTC={(value) => {
                          if (value === "24:00") {
                            setRequisitions((prev) =>
                              prev.map((req, i) =>
                                i === index
                                  ? {
                                      ...req,
                                      startTime: "00:00",
                                      endTime: "24:00",
                                    }
                                  : req,
                              ),
                            );
                          } else {
                            setRequisitions((prev) =>
                              prev.map((req, i) =>
                                i === index
                                  ? { ...req, startTime: "", endTime: value }
                                  : req,
                              ),
                            );
                          }
                        }}
                        startTime={
                          formatDateElement(tenderEndDate) ===
                            formatDateElement(requisitions[index]?.startDate) &&
                          tenderEndTime
                        }
                        minHr={4}
                        isRtc={isRtc}
                        disabled={isRtc}
                      />
                    </div>
                    <div>
                      <TimeInput
                        type={"endTime"}
                        heading={"End Time"}
                        value={
                          requisitions[index]?.endTime === "23:59"
                            ? "24:00"
                            : requisitions[index]?.endTime
                        }
                        onChange={(value) =>
                          handleRequirementChange(
                            index,
                            "endTime",
                            value === "24:00" ? "23:59" : value,
                          )
                        }
                        startDate={requisitions[index]?.endDate}
                        minutesStep={15}
                        height={35}
                        error={error[`endTime_${index}`]}
                        startTime={requisitions[index]?.startTime}
                        isRtc={isRtc}
                        disabled={isRtc}
                      />
                    </div>
                    <div>
                      <TextInput
                        heading={"Req. Quantity (MW)"}
                        value={requisitions[index]?.quantity}
                        onChange={(value) => {
                          // Reject negative values
                          if (Number(value) < 0) {
                            toast.error(
                              "Quantity cannot be negative",
                              toastProperties,
                            );
                            return;
                          }

                          // Check for more than 3 decimal places
                          if (value && /\.\d{4,}/.test(value)) {
                            toast.error(
                              "Quantity can have maximum 3 decimal places",
                              toastProperties,
                            );
                            return;
                          }

                          if (
                            requisitions[index]?.minQty &&
                            Number(value) < Number(requisitions[index]?.minQty)
                          ) {
                            toast.error(
                              "Quantity should be greater than Minimum Quantity",
                              toastProperties,
                            );
                          } else {
                            handleRequirementChange(index, "quantity", value);
                          }
                        }}
                        type={"number"}
                        step="0.001"
                        example={"Eg. 60.123"}
                        height={35}
                        error={error[`quantity_${index}`]}
                      />
                    </div>
                    <div>
                      <TextInput
                        heading={"Min. Quantity (MW)"}
                        value={requisitions[index]?.minQty}
                        onChange={(value) => {
                          // Reject negative values
                          if (Number(value) < 0) {
                            toast.error(
                              "Minimum Quantity cannot be negative",
                              toastProperties,
                            );
                            return;
                          }

                          // Check for more than 3 decimal places
                          if (value && /\.\d{4,}/.test(value)) {
                            toast.error(
                              "Minimum Quantity can have maximum 3 decimal places",
                              toastProperties,
                            );
                            return;
                          }

                          if (
                            Number(value) >
                            Number(requisitions[index]?.quantity)
                          ) {
                            toast.error(
                              "Minimum Quantity should be less than Required Quantity",
                              toastProperties,
                            );
                          } else {
                            handleRequirementChange(index, "minQty", value);
                          }
                        }}
                        type={"number"}
                        step="0.001"
                        example={"Eg. 60.123"}
                        height={35}
                        error={error[`minQty_${index}`]}
                      />
                    </div>
                    {/* <div>
                      <TextInput
                        heading={"Min. Quantity (MW)"}
                        value={requisitions[index]?.minQty}
                        onChange={(value) => {
                          if (
                            Number(value) >
                            Number(requisitions[index]?.quantity)
                          ) {
                            toast.error(
                              "Minimum Quantity should be less than Required Quantity",
                              toastProperties,
                            );
                          } else {
                            handleRequirementChange(index, "minQty", value);
                          }
                        }}
                        type={"number"}
                        example={"Eg. 60"}
                        height={35}
                        error={error[`minQty_${index}`]}
                      />
                    </div> */}
                    <div
                      className={`display_flex_column_gap_8 ${Styles.alterButtons}`}
                    >
                      <div
                        className={Styles.deleteButton}
                        onClick={() => handleRemoveRequirement(index)}
                        style={{
                          cursor: `${
                            requisitions?.length < 1 ? "no-drop" : "cursor"
                          }`,
                        }}
                      >
                        <DeleteIcon
                          style={{ fontSize: "14px", color: "#8C8A96" }}
                        />
                      </div>
                      <div
                        onClick={() => handleAddRequirement()}
                        className={Styles.addButton}
                      >
                        <AddIcon
                          style={{
                            fontSize: "14px",
                            color: "var(--primary-color-text)",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
              {/* <div className={`display_flex_row ${Styles.tendersection}`}>
                <div>
                  <TextInput
                    heading={"EMD (₹/MW)"}
                    value={Emd}
                    onChange={(value) => handleEmd(value)}
                    type={"number"}
                    example={"Eg. 60"}
                    height={35}
                    error={error?.emd}
                    disabled={true}
                    info={
                      <span style={{ whiteSpace: "pre-line" }}>
                        <strong>Buyer's EMD:</strong> 0
                        <br />
                        <strong>Seller's EMD:</strong> 0
                      </span>
                    }
                  />
                </div>
                <div>
                  <TextInput
                    heading={"Initial Margin (%)"}
                    value={initialMargin}
                    onChange={(value) => handleInitialMargin(value)}
                    type={"number"}
                    example={"Eg. 60"}
                    height={35}
                    error={error?.initialMargin}
                    disabled={true}
                    info={
                      <span style={{ whiteSpace: "pre-line" }}>
                        <strong>Buyer’s Initial Margin</strong>: The percentage
                        of the total transaction value required to be deposited
                        by the Buyer for a single day.
                        <br />
                        <br />
                        <strong>Seller’s Initial Margin</strong>: A fixed margin
                        equivalent to 20% of the total transaction value, to be
                        deposited by the Seller for a single day.
                      </span>
                    }
                  />
                </div>
                <div>
                  <TextInput
                    heading={"Payment Security (# Days)"}
                    value={paymentSecurity}
                    onChange={(value) => handlePaymentSecurity(value)}
                    type={"number"}
                    example={"Eg. 60"}
                    height={35}
                    error={error?.paymentSecurity}
                    disabled={true}
                    info={
                      <span style={{ whiteSpace: "pre-line" }}>
                        <strong>Buyer’s Payment Security:</strong> Calculated as
                        the Buyer’s Initial Margin multiplied by the transaction
                        value for one trading day and the number of days of
                        payment security.
                        <br />
                        <br />
                        <strong>Seller’s Payment Security:</strong> Sellers’
                        initial margin will be considered as payment security.
                      </span>
                    }
                  />
                </div>
                <div></div>
              </div> */}

              <div
                className={`${
                  rfq ? "display_flex_row_gap_16_only" : "display_flex_row"
                } ${Styles.tenderSelection}`}
              >
                <div>
                  <Fileupload
                    accept={".pdf"}
                    id={"general-terms-conditions"}
                    value={generalTC}
                    onChange={handleGeneralTC}
                    height={"35"}
                    heading={"Upload Specific T&C"}
                    example={"Upload T&C (.pdf)"}
                    fileType={"pdf"}
                  />
                </div>
                {rfq ? (
                  <div
                    className={`display_flex_column_gap_8 ${Styles.selectionContainer}`}
                  >
                    <div className={`display_flex_row_gap_8_only`}>
                      <div className={Styles.selectionHeading}>Tender Type</div>
                      <div
                        className={`display_flex_row_center ${Styles.selection_upper}`}
                      >
                        <div
                          className={
                            tenderType === "CLOSED" && Styles.active_tenType
                          }
                          onClick={() => {
                            handleTenderType("CLOSED");
                            handleselectionModalMain("gen");
                          }}
                        >
                          Closed
                        </div>
                        <div
                          onClick={() => {
                            setDefData([]);
                            handleTenderType("OPEN");
                          }}
                          className={
                            tenderType === "OPEN" && Styles.active_tenType
                          }
                        >
                          Open
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        tenderType === "OPEN"
                          ? "disable-button"
                          : "activeButton_type_2"
                      } ${Styles.activeSelectionContainer}`}
                      onClick={() =>
                        tenderType === "CLOSED" &&
                        handleselectionModalMain("gen")
                      }
                    >
                      {defData?.length > 0 ? "View" : "Select"} Participants
                    </div>
                  </div>
                ) : (
                  <div
                    className={`display_flex_column_gap_8 ${Styles.selectionContainer}`}
                  >
                    <div className={`display_flex_row_gap_8_only`}>
                      <div className={Styles.selectionHeading}>
                        Auction Type
                      </div>
                      <div
                        className={`display_flex_row_center ${Styles.selection_upper}`}
                      >
                        <div
                          className={
                            tenderType === "CLOSED" && Styles.active_tenType
                          }
                          onClick={() => handleAuctionTypeSwitch("CLOSED")}
                        >
                          Closed
                        </div>
                        <div
                          onClick={() => handleAuctionTypeSwitch("OPEN")}
                          className={
                            tenderType === "OPEN" && Styles.active_tenType
                          }
                        >
                          Open
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        tenderType === "OPEN"
                          ? "disable-button"
                          : "activeButton_type_2"
                      } ${Styles.activeSelectionContainer}`}
                      onClick={() =>
                        tenderType === "CLOSED" &&
                        handleselectionModalMain("gen")
                      }
                    >
                      {defData?.length > 0 ? "View" : "Select"} Participants
                    </div>
                  </div>
                )}
                {!rfq && (
                  <div
                    className={`display_flex_column_gap_8 ${Styles.selectionContainer}`}
                  >
                    <div className={`display_flex_row_gap_8_only`}>
                      <div className={Styles.selectionHeading}>
                        Trading Committee
                      </div>
                      <div
                        className={`display_flex_row_center ${Styles.selection_upper}`}
                      >
                        <div
                          className={tcm === "yes" && Styles.active_tenType}
                          style={{ cursor: "no-drop" }}
                          // onClick={() => handleTcm("yes")}/
                        >
                          Yes
                        </div>
                        <div
                          onClick={() => handleTcm("no")}
                          className={tcm === "no" && Styles.active_tenType}
                        >
                          No
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        tcm === "yes" ? "activeButton_type_2" : "disable-button"
                      } ${Styles.activeSelectionContainer}`}
                      onClick={() =>
                        tcm === "yes" && handleselectionModalMain("tcm")
                      }
                    >
                      Select TCM Members
                    </div>
                  </div>
                )}
              </div>
              <div className={`display_flex_row ${Styles.tenderComment}`}>
                <TextInput
                  heading={"Comment"}
                  value={comment}
                  onChange={(value) => handleComment(value)}
                  type={"text"}
                  example={"Eg. Comment"}
                  height={35}
                />
              </div>
              {!tenderData?.id && (
                <div className={Styles.level6Continaer}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",

                      fontSize: "12px",
                      color: "#8C8A96",
                      fontWeight: 400,
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{ marginRight: "8px" }}
                      checked={acceptSystemTerms}
                      onChange={(e) => setAcceptSystemTerms(e.target.checked)}
                    />
                    I Understand and Accept&nbsp;
                    <span
                      onClick={() => {
                        handlePreviewGeneralTerms(
                          "https://gna-general-files.s3.ap-south-1.amazonaws.com/Website+Assets+PDF/GNA-bye-laws.pdf",
                          {
                            hideHeader: true,
                          },
                        );
                      }}
                      type="button"
                      style={{
                        color: "#ff9800",
                        cursor: "pointer",
                      }}
                    >
                      Terms and Conditions
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className={`display_flex_row_gap_8 ${Styles.buttonContainer}`}>
              <div className={`activeButton_type_3`} onClick={handleClose}>
                Cancel
              </div>
              {type === "edit" && !duplicate && (
                <div className="delete_button" onClick={handleActivateModal}>
                  Withdraw
                </div>
              )}
              {loading ? (
                <div className={`activeButton`} style={{ width: "100px" }}>
                  <CircularProgress size={"20px"} />
                </div>
              ) : (
                <div
                  className={`activeButton`}
                  // Only allow the click if NOT currently submitting
                  onClick={() => {
                    handleFormSubmit();
                  }}
                  style={{
                    width: "100px",
                    // Optional: Add visual cues that it is disabled
                    opacity: isSubmitting ? 0.6 : 1,
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                  }}
                >
                  {/* Optional: Change text while processing */}
                  {isSubmitting
                    ? "Wait..."
                    : type === "edit" && !duplicate
                      ? "Update"
                      : "Submit"}
                </div>
              )}
            </div>
          </div>
        </>
      </Modal>
    </>
  );
};

export default CreateTender;
